import { getDefaultConfiguration } from '@nv/contexts'

const getConfigurations = ({ t }) => {
  const defaultConfiguration = getDefaultConfiguration(t)

  return {
    ...defaultConfiguration,
    languages: {
      en: 'English',
      fr: 'Francais',
    },
    votingMethodOptions: [
      { label: t('admin.electorsList.votedChannelOptions.mail'), value: 'mail' },
      // { label: t('admin.electorsList.votedChannelOptions.inPerson'), value: 'inPerson' },
      // { label: t('admin.electorsList.votedChannelOptions.online'), value: 'online' },
    ],
    voteByMailDeliveryEndDate: new Date('Oct 4 2025 00:01:00 GMT-0600 (Atlantic Standard Time)'),
    electionDate: new Date(),
    minAge: 18,
    includeSingleNameField: false,
    includeWebAuthnLoginAdmin: true,
    maxSessionTimeMinsAdmin: 4 * 60,
    maxSessionTimeMinsVoter: 30,
    votingDistrictOptions: [],
    includeLoginButtonRegistrationPage: false,
    defaultVotingMethod: 'mail',
    enableManualEntryAddress: true,
    registeredOnlinefilterOptions: [
      {
        key: 'statusFilter',
        isMulti: true,
        label: t('admin.electorsList.status'),
        options: [
          { value: 'Pending', label: t('registration.registrationStatus.pending'), default: true },
          { value: 'PendingIssue', label: t('registration.registrationStatus.pendingissue'), default: true },
          { value: 'Approved', label: t('registration.registrationStatus.approved') },
          { value: 'Declined', label: t('registration.registrationStatus.declined') },
        ],
      },
      {
        key: 'voteByMailAddressFilter',
        isMulti: false, //TODO: implement per filter multiselect setting
        label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailAddressFilterLabel'),
        options: [
          { value: 'all', label: t('main.all') },
          { value: 'International', label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailAddressFilter.International') },
          { value: 'USA', label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailAddressFilter.USA') },
          { value: 'Canada', label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailAddressFilter.Canada') },
          { value: 'Alberta', label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailAddressFilter.Alberta') },
          { value: 'Calgary', label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailAddressFilter.Calgary') },
        ],
      },
      {
        key: 'districtFilter',
        label: t('Ward'),
        options: [
          { value: 'all', label: t('main.all') },
          { value: '1', label: '1' },
          { value: '2', label: '2' },
          { value: '3', label: '3' },
          { value: '4', label: '4' },
          { value: '5', label: '5' },
          { value: '6', label: '6' },
          { value: '7', label: '7' },
          { value: '8', label: '8' },
          { value: '9', label: '9' },
          { value: '10', label: '10' },
          { value: '11', label: '11' },
          { value: '12', label: '12' },
          { value: '13', label: '13' },
          { value: '14', label: '14' },
          { value: 'unknown', label: 'Unknown' },
        ],
      },
      {
        key: 'channelFilter',
        label: t('admin.electorsList.votingChannel'),
        isMutli: false,
        options: [
          { value: 'all', label: t('main.all'), default: true },
          { value: 'inPerson', label: t('admin.electorsList.votedChannelOptions.inPerson') },
          { value: 'mail', label: t('admin.electorsList.votedChannelOptions.mail') },
        ],
      },
    ],
    eligibleListfilterOptions: [
      {
        key: 'voteByMailFilter',
        isMulti: true,
        label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailFilterLabel'),
        options: [
          { value: 'Approved', label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailFilter.Approved') },
          { value: 'Printed', label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailFilter.Printed') },
          { value: 'Ready', label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailFilter.Ready') },
          { value: 'Received', label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailFilter.Received') },
          { value: 'ReceivedIssue', label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailFilter.ReceivedIssue') },
          { value: 'Validated', label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailFilter.Validated') },
        ],
      },
      {
        key: 'voteByMailAddressFilter',
        isMulti: false,
        label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailAddressFilterLabel'),
        options: [
          { value: 'all', label: t('main.all') },
          { value: 'International', label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailAddressFilter.International') },
          { value: 'USA', label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailAddressFilter.USA') },
          { value: 'Canada', label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailAddressFilter.Canada') },
          { value: 'Alberta', label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailAddressFilter.Alberta') },
          { value: 'Calgary', label: t('admin.electorsList.registeredOnlinefilterOptions.voteByMailAddressFilter.Calgary') },
        ],
      },

      {
        key: 'channelFilter',
        label: t('admin.electorsList.votingChannel'),
        isMutli: false,
        options: [
          { value: 'all', label: t('main.all'), default: true },
          { value: 'inPerson', label: t('admin.electorsList.votedChannelOptions.inPerson') },
          { value: 'mail', label: t('admin.electorsList.votedChannelOptions.mail') },
        ],
      },
      {
        key: 'districtFilter',
        label: t('Ward'),
        options: [
          { value: 'all', label: t('main.all') },
          { value: '1', label: '1' },
          { value: '2', label: '2' },
          { value: '3', label: '3' },
          { value: '4', label: '4' },
          { value: '5', label: '5' },
          { value: '6', label: '6' },
          { value: '7', label: '7' },
          { value: '8', label: '8' },
          { value: '9', label: '9' },
          { value: '10', label: '10' },
          { value: '11', label: '11' },
          { value: '12', label: '12' },
          { value: '13', label: '13' },
          { value: '14', label: '14' },
          { value: 'unknown', label: 'Unknown' },
        ],
      },
      {
        key: 'statusFilter',
        label: 'Voting Status',
        options: [
          { value: 'all', label: t('main.all') },
          { value: 'voted', label: t('admin.electorsList.eligibleVoterStatusOptions.voted') },
        ],
      },
    ],
    includeOnlineVoterAuth: false,
    registrationPhoneRequired: true,
    registrationIncludeSupportingDocument: false,
    // displayStrikeOffOnlyVotingChannels: ['mail', 'inPerson'],
    includeKnownIdNumber: false,
  }
}
export default getConfigurations
